import UtilServices from "@services/UtilServices";
import "./MenuHeader.scss";
import IconGaveta from "@icons/IconGaveta";
import IconPerfil from "@icons/IconPerfil";
import { useContext, useEffect, useState } from "react";
import Apps from "@components/apps/Apps";
import useAutenticar from "@hooks/useAutenticar";
import usePermissoes from "@hooks/usePermissoes";
import { useNavigate } from "react-router-dom";
import useLst from "@hooks/useLst";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import GlobalContext from "@context/GlobalContext";
import MessageServices from "@services/MessageServices";
import Switch from "@components/switch/Switch";
import IconLogoNuvem from "@icons/IconLogoNuvem";
import EndPointServices from "@services/ApiServices";

export default function MenuHeader(props) {
  //Variaveis padrões
  const [state, dispatch] = useContext(GlobalContext);
  const { handleLogout } = useAutenticar();
  const { handlePermissoes } = usePermissoes();
  const navigate = useNavigate();

  //Open
  const [openApps, setOpenApps] = useState(false);
  const [openPerfil, setOpenPerfil] = useState(false);

  //LstApp
  const { lstApps } = useLst();

  //LstPerfil
  const [permissoesUsuario, setPermissoesUsuario] = useState([]);
  const [perfilselecionado, setPerfilSelecionado] = useState([]);

  //Switch Temas
  const lstSwitchTemas = [
    { button: "<i class='fa-solid fa-sun-bright'></i>" },
    { button: "<i class='fa-regular fa-moon'></i>" },
  ];

  useEffect(() => {
    handleMapearFlgAtivoPefil();
    setPerfilSelecionado(state.perfilselecionado);
  }, []);

  useEffect(() => {
    setPerfilSelecionado(state.perfilselecionado);
    handleMapearFlgAtivoPefil();
  }, [state]);

  useEffect(() => {
    if (state.perfilselecionado.length > 0) {
      handleConsultarMenuLateral();
    }
  }, [state.perfilselecionado]);

  function handleMapearFlgAtivoPefil() {
    // Função para atualizar as permissões, adicionando flgAtivo quando o idPerfil for igual ao idPerfilSelecionado
    const atualizarPermissoesComFlgAtivo = (
      permissoesUsuario,
      perfilSelecionado,
    ) => {
      return Object.values(permissoesUsuario).map((perfil) => {
        // Verifica se o idPerfil do perfil está na array de perfilSelecionado
        const perfilEncontrado = perfilSelecionado.find(
          (selecionado) => selecionado.idPerfil === perfil.idPerfil,
        );

        // Se encontrar o perfil na array e o idPerfil for igual, adiciona flgAtivo
        if (perfilEncontrado) {
          return { ...perfil, flgAtivo: true };
        }

        // Caso contrário, retorna o perfil sem modificações
        return perfil;
      });
    };

    // Supondo que state tenha as permissões e o perfil selecionado
    const permissoesUsuarioAtualizadas = atualizarPermissoesComFlgAtivo(
      state.permissoesusuario,
      state.perfilselecionado,
    );

    // Atualiza o estado com as permissões modificadas
    setPermissoesUsuario(permissoesUsuarioAtualizadas);
  }
  function handleMudarPerfil(item) {
    let perfilselecionado = UtilServices.perfilFiltrar(
      state.permissoesusuario,
      item?.idPerfil,
    );

    if (!perfilselecionado) {
      return MessageServices.ShowWarning("Perfil não disponivel para o App !");
    }

    UtilServices.setStorage("perfilselecionado", perfilselecionado);
    dispatch({
      type: "SET_PERFILSELECIONADO",
      payload: perfilselecionado,
    });

    setOpenPerfil(false);
    window.location.reload();
  }
  function handleMudarTema(e) {
    // id:1 dark
    // id:0 light
    if (e.id === 0) {
      document.body.setAttribute("theme", "light");
      UtilServices.setStorage("tema", "light");
      dispatch({
        type: "SET_TEMA",
        payload: "light",
      });
    } else {
      document.body.setAttribute("theme", "dark");
      UtilServices.setStorage("tema", "dark");
      dispatch({
        type: "SET_TEMA",
        payload: "dark",
      });
    }
  }
  async function handleConsultarMenuLateral() {
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      ID_Perfil: state?.perfilselecionado?.[0]?.idPerfil,
    };

    try {
      var retornoapi = await EndPointServices.Partilha_ConsultarMenuLateral(
        data,
      );
      if (retornoapi.Success) {
        let menulateral = handleConstruindoHierarquia(
          retornoapi?.BaseReturn?.LstClasse,
        );

        dispatch({
          type: "SET_MENULATERAL",
          payload: menulateral,
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  // Função para montar hierarquia
  function handleConstruindoHierarquia(menus) {
    const tree = {};

    menus.forEach((item) => {
      const [index, ...labelParts] = item.Menus.split(" ");
      const levels = index.split(".");
      const label = labelParts.join(" ");
      const disabled = item.Disabled;
      const icon = item.Icon;
      const url = item.URL;

      let current = tree;

      levels.forEach((level, i) => {
        const key = levels.slice(0, i + 1).join(".");

        if (!current[key]) {
          current[key] = {};
        }

        // Quando for o último nível, adiciona os dados
        if (i === levels.length - 1) {
          current[key] = {
            label,
            url,
            icon,
            disabled,
          };
        }

        current = current[key];
      });

      // No nível raiz, adiciona o nome do pai com base em Descricao
      const rootLevel = levels[0];
      if (!tree[rootLevel]) {
        tree[rootLevel] = {};
      }
      if (!tree[rootLevel].label) {
        tree[rootLevel].label = item.MenuPai;
        tree[rootLevel].icon = item.Icon_Pai;
        tree[rootLevel].disabled = item.DisabledPai;
      }
    });

    return tree;
  }

  return (
    <div className="menuheader">
      <IconLogoNuvem
        width="200"
        onClick={() => {
          navigate("/home");
        }}
      />
      {state.dadosusuario?.TipoImagem_Cliente === "png" ? (
        <img
          className="imagem-logo-cliente"
          data-tooltip-id="tooltip-003"
          data-tooltip-content={state.dadosusuario?.ToolTipLogo_Cliente}
          src={`data:image/png;base64,${
            UtilServices.getStorage("tema") === "light"
              ? state.dadosusuario?.LogoImgLight_Cliente
              : state.dadosusuario?.LogoImgDark_Cliente
          }`}
          alt="Base64"
        />
      ) : (
        state.dadosusuario?.TipoImagem_Cliente === "svg" && (
          <div
            className="imagem-logo-cliente"
            data-tooltip-id="tooltip-003"
            data-tooltip-content={state.dadosusuario?.ToolTipLogo_Cliente}
          >
            {UtilServices.stringToJsx(
              UtilServices.getStorage("tema") === "light"
                ? state.dadosusuario?.LogoSvgLight_Cliente
                : state.dadosusuario?.LogoSvgDark_Cliente,
            )}
          </div>
        )
      )}
      <div className="menuheader-suspenso">
        <div className="icon-gaveta">
          <IconGaveta
            onClick={() => {
              setOpenApps(!openApps);
            }}
          />
          {openApps && (
            <div className="menuheader-apps">
              {lstApps.map((item, index) => (
                <Apps
                  index={index}
                  icon={item.icon}
                  tpIcon={item.tpIcon}
                  desc={item.desc}
                  title={item.title}
                  disabled={!handlePermissoes(item.id)}
                  onClick={item.onClick}
                  background={item.background}
                  setOpenApps={setOpenApps}
                />
              ))}
            </div>
          )}
        </div>
        <div className="menuheader-usuario">
          <div className="menuheader-nome-ultimoacesso">
            <p className="menuheader-nome">{props.nome}</p>
            <p className="menuheader-ulitmoacesso">{`Utimo Acesso: ${props.ultimoAcesso}`}</p>
          </div>
          <div className="menuheader-notificar">
            {state.notificacao > 0 && (
              <div
                className={`menuheader-notificar-qtd ${
                  !handlePermissoes(4, "Notificacao", "Consultar")
                    ? "disabled"
                    : ""
                }`}
              ></div>
            )}
            <ButtonIcon
              Notificacao
              disabledNotificacao={
                !handlePermissoes(4, "Notificacao", "Consultar")
              }
              onNotificacao={() => {
                navigate("/CentralNotificacao");
              }}
              titleNotificacao={`Você tem ${state.notificacao} ${
                state.notificacao === 1 ? "notificação" : "notificações"
              }`}
            />
          </div>
          <div className="menuheader-perfil">
            <IconPerfil />
            <ButtonIcon
              Arrow
              openSetArrow={openPerfil}
              setOpenSetArrow={setOpenPerfil}
              onArrow={() => {
                setOpenPerfil(!openPerfil);
              }}
            />
            {openPerfil && (
              <div className="menuheader-lstperfil">
                {Object.values(permissoesUsuario)
                  .filter(
                    (value, index, self) =>
                      index ===
                      self.findIndex((t) => t.nomePerfil === value.nomePerfil),
                  ) // Filtra duplicatas
                  .map((item, index) => (
                    <div
                      key={index} // Adicionando chave única para cada item
                      className={`menuheader-lstperfil-detalhe ${
                        item?.flgAtivo ? "ativo" : ""
                      }`}
                      onClick={() => {
                        handleMudarPerfil(item);
                      }}
                    >
                      <p>{item?.nomePerfil}</p>
                    </div>
                  ))}
              </div>
            )}
          </div>
          <p
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleLogout();
            }}
          >
            sair
          </p>
        </div>
      </div>
      <Switch
        className="temas"
        lstSwitch={lstSwitchTemas}
        default={UtilServices.getStorage("tema") === "light" ? 0 : 1}
        setRetorno={(e) => handleMudarTema(e)}
      />
    </div>
  );
}

MenuHeader.defaultProps = {
  nome: "Admin",
  qtdNotificacoes: 1,
  ultimoAcesso: "16/12/2024 11:01",
};
